module.exports = __webpack_public_path__ + "img/welfare-storevip.3e42c250.png";